<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">{{ $t("student.gradebook") }}</h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100 md-layout">
          <div class="md-layout-item md-size-25 md-xsmall-size-100">
            <md-field>
              <label class="text-sm">{{ $t("common.program") }}</label>
              <md-select
                v-model="programsSelect.value"
                @click="getProgram('reFetch')"
              >
                <md-option
                  v-for="option in programsSelect.options"
                  :value="option.id"
                  :key="option.id + option.name"
                  >{{ option.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div
            class="md-layout-item md-size-75 text-right md-xsmall-size-100"
            v-if="$can(Student.actions.exportGradebook, Student.subject)"
          >
            <md-button
              @click="exportPDF()"
              class="md-warning"
              v-if="tableData.length"
              >{{ $t("extended_exportation.export_file") }}
            </md-button>
          </div>
        </div>
        <div class="md-layout-item md-size-100 md-layout" v-if="gpa">
          <div class="md-layout-item md-size-50 md-xsmall-size-100">
            <p class="gradebook-header">
              {{ this.$t("dashboard.synthetic.gpa") }}: {{ gpa.gpa }}
            </p>
            <p class="gradebook-header">
              {{ this.$t("dashboard.synthetic.gpa_with_bonus_point") }}:
              {{ gpa.gpa_with_bonus_point }}
            </p>
          </div>
          <div class="md-layout-item md-size-50 md-xsmall-size-100">
            <p class="gradebook-header">
              {{
                this.$t("gradebook.class_rank", {
                  numberRank: gpa.rankGpa,
                  numberStudent: gpa.count_student_class
                })
              }}
            </p>
            <p class="gradebook-header">
              {{
                this.$t("gradebook.rank_with_bonus_point", {
                  numberRank: gpa.rankGpa,
                  numberStudent: gpa.count_student_class
                })
              }}
            </p>
          </div>
        </div>
        <div class="form-table md-layout-item md-size-100">
          <yv-table
            :tableData="tableData"
            :hideAction="true"
            :selectedItems="selectedItems"
            :pagination="pagination"
            :columns="columns"
            :sortData="sortDataDefault"
            v-if="tableData.length"
          >
          </yv-table>
          <div v-else>
            <no-data-found></no-data-found>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { service_paths } from "@/constants/Services";
import YvTable from "@/components/Base/YvTable";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import { Message } from "@/helpers/utils";
import { Student } from "@/constants/Permissions";

export default {
  name: "grade-book",
  components: { YvTable, NoDataFound },
  props: ["isActiveTab"],
  data() {
    return {
      Student,
      tableData: [],
      selectedItems: [],
      sortDataDefault: {
        currentSort: "id",
        currentSortOrder: "desc"
      },
      pagination: {
        perPage: 10,
        from: 0,
        hidePerPageOptions: true,
        to: 0,
        total: 0,
        currentPage: 0
      },
      columns: {
        subject: "common.subject",
        class: "gradebook.class",
        terms: "gradebook.term",
        fullNameTeacher: "gradebook.primaryTeacher",
        score: "gradebook.courseScore",
        letter: "gradebook.mark",
        credit: "gradebook.credits",
        weight: "gradebook.weight"
      },
      programsSelect: {
        options: [],
        value: ""
      },
      gpa: "",
      dataBottom: [],
      isActive: false
    };
  },
  computed: {
    studentId() {
      return this.$route.params.id;
    }
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.getProgram();
        this.isActive = true;
      }
    },
    "programsSelect.value"(newProgram) {
      newProgram && this.getDetailData();
    }
  },
  methods: {
    getDetailData() {
      this.$axios
        .get(`${service_paths.students}/${this.studentId}/grade-book`, {
          program: this.programsSelect.value
        })
        .then(response => {
          this.dataBottom = response.data.dataBottom;
          this.tableData = this.dataBottom.map((data, index) => ({
            noNumb: index + 1,
            subject: data.subject_no + " - " + data.subject_name,
            fullNameTeacher: data.username,
            ...data
          }));
          let dataGpa = response.data.dataGpa;
          this.gpa = {
            gpa: dataGpa?.gpa?.toFixed(1),
            gpa_with_bonus_point: dataGpa?.gpa_with_bonus_point?.toFixed(1),
            rankGpa: dataGpa.rankGpa,
            rankGpaWithBonusPoint: dataGpa.rankGpaWithBonusPoint,
            count_student_class: dataGpa.count_student_class,
            userId: dataGpa.userId
          };
        })
        .catch(() => {
          this.gpa = "";
          this.tableData = [];
        });
    },

    getProgram(event) {
      this.$axios
        .get(`${service_paths.students}/${this.studentId}/programs`)
        .then(response => {
          this.programsSelect.options = response.data.sort(
            (currentProgram, newProgram) => {
              return currentProgram.name.localeCompare(newProgram.name);
            }
          );
          if (event === "reFetch") {
            if (!this.programsSelect.options.length) {
              Message.error(this.$t("program.program_not_exist"));
              this.programsSelect.value = "";
              this.gpa = "";
              this.tableData = [];
            }
          } else {
            this.programsSelect.value = this.programsSelect.options[0]?.id;
          }
        });
    },
    exportPDF() {
      let programName = this.programsSelect.options.find(
        program => program.id === this.programsSelect.value
      ).name;
      let data = {
        dataGpa: this.gpa,
        dataBottom: this.dataBottom,
        program_name: programName
      };
      this.$axios
        .post(
          `${service_paths.export}/grade-book/pdf/student/${this.studentId}`,
          data,
          undefined,
          undefined,
          "blob"
        )
        .then(response => {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            Message.success(this.$t("common.export_success"));
            link.setAttribute("download", "gradebook.pdf");
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            Message.error(this.$t("common.an_error_occurred"));
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.gradebook-header {
  @apply text-base leading-[26px] text-[#000] font-semibold my-2;
}
</style>
